import { call, put } from 'redux-saga/effects';
import { board, WhiteboardData } from 'utils/whiteboard/BoardStateManager';
import { parseWhiteboardStateSaga } from 'features/whiteboard/sagas/parseWhiteboardStateSaga';
import { manageWhiteboardEncryptionSaga } from 'features/whiteboard/sagas/manageWhiteboardEncryptionSaga';
import { whiteboardIdUpdated } from 'features/whiteboard/whiteboardSlice';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { SignalingWhiteboardPayload } from 'features/layout/features/content/types';
import { EventUser } from 'services/signaling';

interface InitWhiteboardOptions {
  readOnly?: boolean;
}

export function* initWhiteboardSaga(
  data: SignalingWhiteboardPayload,
  initiator: EventUser,
  { readOnly = false }: InitWhiteboardOptions = {}
) {
  yield call(manageWhiteboardEncryptionSaga, data.id, initiator);

  const whiteboardData: WhiteboardData = {
    id: data.id,
    name: data.name,
    shapes: [],
  };

  if (data.shapes.length) {
    whiteboardData.shapes = yield call(parseWhiteboardStateSaga, data.id, data.shapes);
  }

  yield call(board.init, whiteboardData);

  yield put(whiteboardIdUpdated(data.id));

  if (readOnly) {
    yield call(board.stop);
    return;
  }

  const canEditWhiteboard: boolean = yield call(hasPermissionsSaga, PermissionTypes.editWhiteboard);

  if (canEditWhiteboard) {
    yield call(board.watch);
  } else {
    yield call(board.stop);
  }
}
